// JsFromRoutes CacheKey 12ce43c3067694567eeba4cf2185b38f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@/utils/definePathHelper'

export default {
  passthru: /* #__PURE__ */ definePathHelper('post', '/users/auth/discord'),
  discord: /* #__PURE__ */ definePathHelper('post', '/users/auth/discord/callback'),
}
